import { makeAutoObservable } from 'mobx';
import { RootStore } from 'store/rootStore';

export type NotificationModalType = 'ENROLL' | 'CONTACT_ME' | 'ERROR';

interface NotificationModalData {
  title: string;
  subtitle: string;
  type: NotificationModalType;
}

export class NotificationModalStore {
  rootStore: RootStore;
  isNotificationModalOpen = false;
  modalData: NotificationModalData = { title: '', subtitle: '', type: 'CONTACT_ME' };

  private setNotificationModalStatus(modalData: NotificationModalData): void {
    this.modalData = modalData;
  }

  public openNotificationModal(modalData: NotificationModalData): void {
    this.setNotificationModalStatus(modalData);
    this.isNotificationModalOpen = true;
  }

  public closeNotificationModal(): void {
    this.isNotificationModalOpen = false;
    this.setNotificationModalStatus({ title: '', subtitle: '', type: 'CONTACT_ME' });
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    makeAutoObservable(this, {}, { autoBind: true });
  }
}
